/**
 * Converte as declaracoes `nav` dos modulos no mapa que o buildMenu consome.
 *
 * Separado do navRegistry porque este arquivo nao pode depender do Vite: e
 * assim que ele fica testavel com `node --test`.
 */
export function navDosModulos(modulos = {}) {
    return Object.values(modulos).reduce((mapa, modulo) => {
        const nav = modulo?.nav;

        if (!nav?.section || !nav?.title) {
            return mapa;
        }

        mapa[`${nav.section}/${nav.title}`] = {
            icon: nav.icon,
            route: nav.route,
            accordion: nav.accordion ?? false,
        };

        return mapa;
    }, {});
}

/**
 * As declaracoes `nav` cruas, como os modulos escreveram.
 *
 * O `navDosModulos` acima achata para o mapa por caminho de titulos, que era o
 * que o buildMenu antigo consumia. Este devolve o objeto inteiro -- com
 * `section`, `permissao` e `sequence` -- porque o `montarMenu` monta a
 * estrutura a partir dele, sem passar por casamento de texto.
 */
export function navsDosModulos(modulos = {}) {
    return Object.values(modulos)
        .map((modulo) => modulo?.nav)
        .filter((nav) => nav?.title && nav?.route);
}

/**
 * Lista plana dos modulos declarados, na ordem em que o glob os entrega.
 *
 * O menu normal vem da arvore de permissoes do /appmenu. Este aqui e a rede de
 * seguranca: usuario de grupo admin ignora a arvore, e enquanto o catalogo
 * proprio do accounts nao estiver cadastrado a arvore volta vazia para todo
 * mundo. Sem isto, quem precisa entrar para *criar* o catalogo nao teria como
 * navegar ate a tela.
 */
export function modulosDeclarados(modulos = {}) {
    return Object.values(modulos)
        .map((modulo) => modulo?.nav)
        .filter((nav) => nav?.title && nav?.route)
        .map((nav) => ({ title: nav.title, icon: nav.icon || 'folder', route: nav.route }));
}
